export class InvoicingRequestModel {
  invoicingCutoffId: number = 0;
  dateInvoicing: Date = new Date;
  invoiceExpirationDays: number = 0;
  movementToInvoice: Array<number> = new Array<number>();
}